var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EditorTag } from "@easydata/core";
/** Represents editor tags*/
export var EqEditorTag = __assign(__assign({}, EditorTag), { 
    /** SqlList tag value */
    SqlList: "SQLLIST", 
    /** SubQuery tag value */
    SubQuery: "SUBQUERY", 
    /** Bind to parent column tag value */
    BindToParentColumn: "BINDTOPARENTCOLUMN" });
//# sourceMappingURL=eq_editor_tag.js.map